export const contentTypeRow = [
  {
    name: '100%',
    type: 'one-hundred',
    columns: 1,
    grouped: ['main']
  },
  {
    name: '50% - 50%',
    type: 'fifty-fifty',
    columns: 2,
    grouped: ['main']
  },
  {
    name: '60% - 40%',
    type: 'sixty-forty',
    columns: 2,
    grouped: ['main']
  },
  {
    name: '40% - 60%',
    type: 'forty-sixty',
    columns: 2,
    grouped: ['main']
  },
  {
    name: '3 columns',
    type: 'one-third',
    columns: 3,
    grouped: ['main']
  },
  {
    name: 'Four modules collage',
    type: 'four-modules',
    columns: 4,
    grouped: ['main']
  },
  {
    name: 'Three modules collage',
    type: 'three-modules',
    columns: 3,
    grouped: ['main']
  },
  {
    name: 'Carousel',
    type: 'carousel',
    grouped: ['main'],
    columns: 1
  },
  {
    name: 'GridXN',
    type: 'grid-xn',
    columns: 1,
    grouped: ['main']
  }
]

export const contentFindOption = (array, key) => {
  if (Array.isArray(array)) {
    const find = array.find(obj => obj.key === key)
    if (find) {
      return find
    }
  }
  return { key, value: null }
}

export const contentFindContent = (array, key) => {
  if (Array.isArray(array)) {
    const find = array.find(obj => obj.key === key)
    if (find) {
      return find
    }
  }
  return {
    key,
    value: null,
    file: null,
    fileData: null,
    content: [],
    options: []
  }
}
